import { QuickLinkName } from './types';

export const DEFAULT_ORDER = [
  QuickLinkName.CANVA,
  QuickLinkName.CREATE_OFFER,
  QuickLinkName.CREATE_LISTING,
  QuickLinkName.CREATE_LEASE,
  QuickLinkName.GROWTH_HUB,
  QuickLinkName.START_REFERRAL,
  QuickLinkName.RECEIVE_REFERRAL,
  QuickLinkName.USER_TEMPLATES,
  QuickLinkName.PRICING_PLAN_PROGRESS_REPORT,
  QuickLinkName.GROWTH_REPORT,
  QuickLinkName.FINANCIAL_REPORT,
  QuickLinkName.PLATFORM_FEE_REPORT,
  QuickLinkName.BUYER_AGREEMENT,
];
